import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import axios from "axios";
import { preloadModule } from "react-dom";
import { faF } from "@fortawesome/free-solid-svg-icons";
import { useProfile } from "../contexts/ProfileContext";
import { API_BASE_URL } from '../config/api';
import axiosClient from "../api/axiosClient";
import Alert from "./Alert";
import { useLanguage } from "../contexts/LanguageContext";

const ToolsIdea = () => {
	const L = useLanguage();
	const [goal, setGoal] = useState("");
	const [targetAudience, setTargetAudience] = useState("");
	const [topic, setTopic] = useState("");
	const [tone, setTone] = useState("");
	const [ideas, setIdeas] = useState([]);
	const [generating, setGenerating] = useState(false);
	const [functionError, setFunctionError] = useState("");
	const [functionSuccess, setFunctionSuccess] = useState("");

	const profile = useProfile();
	
	const generateIdea = async () => {

		try {
			const formData = {};
			formData.age = profile.ageRange;
			formData.gender = profile.genderTarget;
			formData.country = "USA";
			formData.niche = profile.interests;
			formData.goal = goal;
			formData.targetAudience = targetAudience;
			formData.topic = topic;
			formData.tone = tone;

			
		

			setGenerating(true);
			setIdeas([]);
		
			const response = await axiosClient.post("https://api.viralgpt.com/tools/idea", formData, {
			headers: {
				"Content-Type": "application/json",
			},
			});
			setGenerating(false);
		  	setIdeas(response.data.reply);

			console.log("Server response:", response.data);
			setFunctionSuccess(L.toolsIdea.success);
		} catch (e) {
			setGenerating(false);
			
			setFunctionError(L.toolsIdea.generateError(e.response?.data?.error || e.message || L.toolsIdea.unknownError));
		}
	};



  return (
	<>
		<div className="bg-white border  p-6">
			<h5>{L.toolsIdea.heading}</h5>
			<p className="text-muted">{L.toolsIdea.subtitle}</p>

			<Alert 
                variant="danger" 
                message={functionError} 
                show={!!functionError} 
            	onClose={() => setFunctionError("")} 
              />
              
              <Alert 
            	variant="success" 
                message={functionSuccess} 
                show={!!functionSuccess} 
                onClose={() => setFunctionSuccess("")} 
              />

			{/* Goal Dropdown */}
			<Form.Group controlId="goalSelect" className="mb-3">
			<Form.Label>{L.toolsIdea.goalLabel}</Form.Label>
			<Form.Select
				value={goal}
				onChange={(e) => setGoal(e.target.value)}
				aria-label={L.toolsIdea.goalAria}
			>
				<option value="">{L.toolsIdea.goals.none}</option>
				<option value="brandAwareness">{L.toolsIdea.goals.brandAwareness}</option>
				<option value="boostEngagement">{L.toolsIdea.goals.boostEngagement}</option>
				<option value="productLaunch">{L.toolsIdea.goals.productLaunch}</option>
				<option value="increaseSales">{L.toolsIdea.goals.increaseSales}</option>
				<option value="educateAudience">{L.toolsIdea.goals.educateAudience}</option>
				{/* Add more goals if needed */}
			</Form.Select>
			</Form.Group>

			{/* Target Audience Input */}
			<Form.Group controlId="targetAudience" className="mb-3">
			<Form.Label>{L.toolsIdea.targetAudienceLabel}</Form.Label>
			<Form.Control
				type="text"
				placeholder={L.toolsIdea.targetAudiencePlaceholder}
				value={targetAudience}
				onChange={(e) => setTargetAudience(e.target.value)}
			/>
			</Form.Group>

			{/* Topic or Niche */}
			<Form.Group controlId="topic" className="mb-3">
			<Form.Label>{L.toolsIdea.topicLabel}</Form.Label>
			<Form.Control
				type="text"
				placeholder={L.toolsIdea.topicPlaceholder}
				value={topic}
				onChange={(e) => setTopic(e.target.value)}
			/>
			</Form.Group>

			{/* Tone Dropdown */}
			<Form.Group controlId="toneSelect" className="mb-3">
			<Form.Label>{L.toolsIdea.toneLabel}</Form.Label>
			<Form.Select
				value={tone}
				onChange={(e) => setTone(e.target.value)}
				aria-label={L.toolsIdea.toneAria}
			>
				<option value="">{L.toolsIdea.tones.none}</option>
				<option value="informative">{L.toolsIdea.tones.informative}</option>
				<option value="casual">{L.toolsIdea.tones.casual}</option>
				<option value="humorous">{L.toolsIdea.tones.humorous}</option>
				<option value="persuasive">{L.toolsIdea.tones.persuasive}</option>
				{/* Add more tones if needed */}
			</Form.Select>
			</Form.Group>

			{/* Start Delivery (Generate Idea) Button */}
			<div className="d-flex align-items-center">
				<Button variant="primary" className={generating ? "disabled bg-instagram" : "bg-instagram"} onClick={() => generateIdea()}>
					{L.toolsIdea.generateButton}
				</Button>
				<Button
					variant="primary"
					className={ideas.length == 0 ? "d-none bg-instagram" : "ms-2 bg-instagram"}
					onClick={() => generateIdea()}
				>
					<i className="fa fa-arrows-rotate text-white"/>
				</Button>
				<div style={{fontSize: "1.5rem"}} className={`ms-2 fa fa-circle-notch fa-spin text-instagram ${!generating ? "d-none" : ""}`}/>
			</div>
				<div className="mt-3">
					{ideas.map((idea, index) => (
						<div
						key={index}
						style={{
							display: "flex",
							alignItems: "center",  // Ensures vertical centering in flex container
							marginBottom: "1rem",  // Optional spacing between rows
						}}
						>
						<button
							style={{ marginRight: "1rem" }} // Space between button & text
						>
							{index == 0 ? <i className="fa fa-image  text-instagram"></i> : index == 1 ? <i className="fa fa-video text-instagram"></i> : <i className="fa fa-book text-instagram"></i>}
							

							

							


						</button>
						<p style={{ margin: 0 }}>{idea}</p> 
						</div>
					))}
				</div>
		</div>
	</>
  );
};

export default ToolsIdea;
